import React, { Component } from 'react'

class Form extends Component {
  render() {
    return (
      <form></form>
    )
  }
}

export default Form